/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DateRestrictionUnit {
  Days = 'Days',
  Months = 'Months',
  Years = 'Years'
}
